const chatttSDK = window?.__CHATTT_SDK__;
export const syncSysSettings = (settings: Chattt.SystemSettings) => {
  if (chatttSDK?.syncSysSettings) {
    chatttSDK.syncSysSettings(settings);
  }
};

export default chatttSDK;
